import { configureStore } from '@reduxjs/toolkit'
import generalDataReducer from './features/general-data/general-data-slice'
import analyticsScopeReducer from './features/analytics-scope/analytics-scope-slice'
import userApiReducer from './api/user-api'
import analyticsApi from './api/analytics-api'
import settingsApi from './api/settings-api'

export const store = configureStore({
  reducer: {
    generalData: generalDataReducer,
    analyticsScope: analyticsScopeReducer,
    userApi: userApiReducer,
    analyticsApi: analyticsApi,
    settingsApi: settingsApi
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({}).concat([])
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
